import { cachedApiCall } from './api';
import type { Badge, Passport, Skillstree } from '../types/achievement';

// Mock data for fallback (you should define these)
const mockCoreCategories: any[] = [];
const mockSkillstrees: any[] = [];
const mockBadges: Badge[] = [];
const mockPassports: Passport[] = [];

export const achievementsApi = {

  // Fetch all core categories
  async getCoreCategories(): Promise<Array<any>> {
    return cachedApiCall('/v1/core-category', {
      method: 'GET',
      mockData: mockCoreCategories,
      useCache: true,
      cacheTTL: 5 * 60 * 1000 // 5 minutes
    }).then(response => (response?.data as any)?.data as any || response?.data as any);
  },

  // Fetch all skillstrees
  async getSkillstrees(params?: {
    coreCategorySlug?: string;
    skillstreeSlug?: string;
    keywords?: string;
    isEnrolled?: boolean;
  }): Promise<Array<any>> {
    return cachedApiCall('/v1/skillstrees', {
      method: 'GET',
      params,
      mockData: mockSkillstrees,
      useCache: true,
      cacheTTL: 2 * 60 * 1000 // 2 minutes
    }).then(response => (response?.data as any)?.data as any || response?.data as any);
  },

  // Fetch all badges for the current user
  async getBadges(): Promise<Badge[]> {
    return cachedApiCall('/badges', {
      method: 'GET',
      mockData: mockBadges,
      useCache: true,
      cacheTTL: 2 * 60 * 1000 // 2 minutes
    }).then(response => (response?.data as any)?.data as any || response?.data as any);
  },

  // Fetch all passports for the current user
  async getPassports(): Promise<Passport[]> {
    return cachedApiCall('/passports', {
      method: 'GET',
      mockData: mockPassports,
      useCache: true,
      cacheTTL: 2 * 60 * 1000 // 2 minutes
    }).then(response => (response?.data as any)?.data as any || response?.data as any);
  },

  // Verify a badge (don't cache verification calls)
  async verifyBadge(uuid: string): Promise<{ valid: boolean; badge?: Badge }> {
    return cachedApiCall(`/badges/verify/${uuid}`, {
      method: 'GET',
      mockData: { valid: false },
      useCache: false // No caching for verification
    }).then(response => (response?.data as any)?.data as any || response?.data as any);
  },

  // Verify a passport (don't cache verification calls)
  async verifyPassport(uniqueCode: string): Promise<{ valid: boolean; passport?: Passport }> {
    return cachedApiCall(`/passports/verify/${uniqueCode}`, {
      method: 'GET',
      mockData: { valid: false },
      useCache: false // No caching for verification
    }).then(response => (response?.data as any)?.data as any || response?.data as any);
  }
};